import React from 'react';

import { Item } from '../../pages/Market/Item';
import { Text } from '../Text';

import './RecommendedItems.scss';
import { SpecialGroup } from '../../pages/Market/helpers/items';
import { PaymentComponent } from 'pages/Market/types';

interface RecommendedItemsProps {
  recommendGroups: SpecialGroup;
  t: Record<string, any>;
  onItemClick?: (item: any) => void;
  onPaymentClick?: (event: any, item: any, component: PaymentComponent) => void;
}

export const RecommendedItems: React.FC<RecommendedItemsProps> = ({
  recommendGroups,
  t,
  onItemClick = () => undefined,
  onPaymentClick = () => undefined,
}) => {
  if (!recommendGroups) {
    return null;
  }
  // const group = Object.entries(recommendGroups)[0][1];
  const group = recommendGroups;

  if (!group || !group?.items?.length) {
    return null;
  }

  return (
    <div className="recommended-items">
      <Text.HeaderS className="recommended-items__title">
        {t.market.modal.watchMore}:
      </Text.HeaderS>
      <div className="recommended-items__items">
        {group?.items?.slice(0, 4).map((item, index) => (
          <div className="recommended-items__item-wrapper" key={item.sku}>
            <Item
              item={item}
              size="s"
              onItemClick={() => onItemClick(item)}
              onPaymentClick={(event: React.MouseEvent) =>
                onPaymentClick(event, item, 'recommend')
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
};
